<template>
  <div class="addPackageWrapper">
    <q-form @submit="onSubmit" class="form">
      <div class="form__item">
        <CustomInput label="Code Revit" placeholder="Введите код Revit" type="text" :value="formData.code"
          @change_input="value => onChange('code', value)" required />
      </div>
      <div class="form__item">
        <CustomUploader label="Файл Revit" placeholder="Выберите файл Revit" type="file" :value="formData.revit_data"
          @change="value => onChange('revit_data', value)" required />
      </div>
      <CustomModalFooter :btn-loading="loading" submit-btn-text="Загрузить данные" />
    </q-form>
  </div>
</template>

<script>
import CustomInput from "@/components/form/CustomInput";
import CustomModalFooter from "@/components/modal/modals/modal-footer";
import CustomUploader from "@/components/form/CustomUploader";

export default {
  name: "add-revit-data",
  components: { CustomInput, CustomModalFooter, CustomUploader },
  props: ["data"],
  data() {
    return {
      loading: false,
      formData: {
        code: this.data?.body?.code || "",
        revit_data: this.data?.body?.revit_data || null,
      },
    };
  },
  async mounted() { },

  methods: {
    async onChange(key, value) {
      this.formData[key] = value;
    },
    async onSubmit() {
      this.loading = true;
      if (this.formData.revit_data) {
        this.formData.revit_data = this.formData.revit_data[0];
      }
      await this.data?.onSubmit(this.formData);
      this.loading = false;
    },
  },
};
</script>

<style scoped lang="scss">
.addPackageWrapper {
  max-width: 700px;

  @media (max-width: 768px) {
    max-width: 100%;
  }
}

.form {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 15px;
  margin-top: 15px;

  &__item {
    width: 100%;
    display: flex;
    gap: 16px;

    :deep(.custom-date) {
      width: 100%;
      max-width: 100%;
    }
  }

  @media (max-width: 428px) {
    min-width: 100%;
  }
}
</style>
